function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 80 80"
}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.676.79L40 28.118 67.324.794a2.742 2.742 0 013.86 0l8.015 8.016a2.74 2.74 0 010 3.863L51.875 39.997l27.324 27.32a2.74 2.74 0 010 3.864l-8.016 8.015a2.742 2.742 0 01-3.86 0L40 51.876 12.676 79.204a2.742 2.742 0 01-3.86 0L.801 71.19a2.74 2.74 0 010-3.864l27.324-27.32L.797 12.673a2.74 2.74 0 010-3.863L8.812.794A2.75 2.75 0 0112.676.79z",
  fill: "#000"
})));